import { InitPagedData } from "../Utils";
import { JournalVoucherStateTypes, JournalVoucherActionTypes } from "./JournalVoucher.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: JournalVoucherStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
  fetchPaged: resetApiCallState(InitPagedData),
};

const JournalVoucherReducer = (
  state: JournalVoucherStateTypes = INITIAL_STATE,
  action: any
): JournalVoucherStateTypes => {
  switch (action.type) {
    case JournalVoucherActionTypes.FETCH_ALL_JOURNAL_VOUCHER:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case JournalVoucherActionTypes.FETCH_ALL_JOURNAL_VOUCHER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case JournalVoucherActionTypes.FETCH_ALL_JOURNAL_VOUCHER_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case JournalVoucherActionTypes.FETCH_ALL_JOURNAL_VOUCHER_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };
    case JournalVoucherActionTypes.FETCH_PAGED_JOURNAL_VOUCHER:
      return {
        ...state,
        fetchPaged: {
          error: null,
          payload: InitPagedData,
          isPending: true,
          isSuccessful: false,
        },
      };
    case JournalVoucherActionTypes.FETCH_PAGED_JOURNAL_VOUCHER_RESET:
      return {
        ...state,
        fetchPaged: resetApiCallState(InitPagedData),
      };
    case JournalVoucherActionTypes.FETCH_PAGED_JOURNAL_VOUCHER_FAILURE:
      return {
        ...state,
        fetchPaged: {
          payload: InitPagedData,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case JournalVoucherActionTypes.FETCH_PAGED_JOURNAL_VOUCHER_SUCCESS:
      return {
        ...state,
        fetchPaged: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case JournalVoucherActionTypes.FETCH_ONE_JOURNAL_VOUCHER:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case JournalVoucherActionTypes.FETCH_ONE_JOURNAL_VOUCHER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case JournalVoucherActionTypes.FETCH_ONE_JOURNAL_VOUCHER_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case JournalVoucherActionTypes.FETCH_ONE_JOURNAL_VOUCHER_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default JournalVoucherReducer;
